import { Component, computed, inject, input, output, signal } from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { RouterLink } from '@angular/router';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { LucideModule } from '../../../../../shared/modules/lucide.module';
import { CartaoAcessoSicComponent } from '../cartao-acesso-sic/cartao-acesso-sic.component';
import { PedidoSicStore, TIPOS_SOLICITANTE, UNIDADES_FEDERATIVAS } from '../pedido-sic.store';

@Component({
  selector: 'app-etapa-identificacao-sic',
  templateUrl: './etapa-identificacao-sic.component.html',
  styleUrls: ['./etapa-identificacao-sic.component.css'],
  imports: [FormField, LucideModule, NgxMaskDirective, RouterLink, CartaoAcessoSicComponent],
  // O modelo guarda o valor já mascarado: é assim que o cadastro do perfil chega e é assim
  // que a etapa de revisão mostra. As validações normalizam os dígitos por conta própria.
  providers: [provideNgxMask({ dropSpecialCharacters: false })],
})
export class EtapaIdentificacaoSicComponent {
  protected readonly store = inject(PedidoSicStore);

  readonly focarLogin = input(0);

  readonly autenticado = output<void>();

  readonly acessarGov = output<void>();

  readonly seguirAnonimo = output<void>();

  readonly saiu = output<void>();

  readonly tiposSolicitante = TIPOS_SOLICITANTE;
  readonly unidadesFederativas = UNIDADES_FEDERATIVAS;

  readonly mascaraCpf = '000.000.000-00';
  /** Aceita fixo e celular; o ngx-mask escolhe a alternativa pelo que já foi digitado. */
  readonly mascaraTelefone = '(00) 0000-0000||(00) 00000-0000';
  readonly mascaraCep = '00000-000';

  readonly mostrarPendencias = signal(false);

  /** Logradouro, número e bairro passam a ser obrigatórios na correspondência física. */
  readonly correspondencia = computed(
    () => this.store.dadosPedido().formaRecebimento === 'CorrespondenciaFisica'
  );

  /** Os erros que o servidor devolveu para esta etapa (o envio traz o cidadão de volta para cá). */
  readonly errosServidor = computed(() => this.store.errosServidor()['identificacao'] ?? []);

  destacarPendencias(): void {
    this.mostrarPendencias.set(true);
    this.store.identificacaoForm().markAsTouched();
  }
}
